
import { defineComponent, PropType, ref, watch } from 'vue'
import { Question, QuestionValue } from '@/types'
import { ActionBtn } from '../ActionBtn'
import QuestionHeader from './QuestionHeader.vue'

export default defineComponent({
  name: 'Question',
  components: { ActionBtn, QuestionHeader },
  props: {
    config: {
      type: Object as PropType<Question>,
      required: true
    },
    modelValue: {
      type: [Array, Number] as PropType<QuestionValue>
    },
    qIndex: {
      type: Number,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const value = ref(props.modelValue)
    const { emit } = context
    watch(value, (val) => {
      emit('update:modelValue', val)
    })
    return {
      value,
      emit
    }
  }
})
